/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Date: 12/14/20
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { fetchOrgs } from 'actions/orgCreators';
import ViewOrganizations from './ViewOrganizations';

const mapDispatchToProps = dispatch => ({
  poll: () => {
    const POLLING_INTERVAL = 5000;
    dispatch(fetchOrgs);
    const pollingId = setInterval(() => {
      dispatch(fetchOrgs);
    }, POLLING_INTERVAL);

    return () => {
      clearInterval(pollingId);
    };
  },
});

const ViewOrganizationsContainer = connect(undefined, mapDispatchToProps)(ViewOrganizations);

export default ViewOrganizationsContainer;



// WEBPACK FOOTER //
// ./js/components/pages/Admin/sections/Organizations/ViewOrganizations/index.js